import { store } from "../store/store";
import { protectedRoutes } from "./protected-routes";

export const hasAccessToRoute = (route) => {
  const routePath = route.matched[0].path;
  if (routePath === "/supplier/:id/details") {
    //https://tracker.globetrack.ie/issues/7530
    return (
      store.getters.hasAccessTo("suppliers:edit") ||
      store.getters.hasAccessTo("suppliers:view_only")
    );
  }
  const supplierPortalRoutes = ["/home"];
  if (store.getters.userConfig.isSupplier) {
    return supplierPortalRoutes.includes(routePath);
  }
  return protectedRoutes[routePath]
    ? store.getters.hasAccessTo(protectedRoutes[routePath])
    : true;
  // if(isVisible()){
  //   return (protectedRoutes[route.matched[0].path] != null) ?
  //     store.getters.hasAccessTo(`${protectedRoutes[route.matched[0].path]}`)
  //     : true;
  // }else{
  //   return false;
  // }

  // function isVisible(){
  //   let rootName = "/" + route.matched[0].path.match(/^\/([^\/]*).*$/)[1];
  //   return (protectedRoutes[rootName] != null) ?
  //     store.getters.hasAccessTo(`${protectedRoutes[rootName]}`)
  //     : true;
  // }
};



// WEBPACK FOOTER //
// ./src/router/route-access.js